import { useCallback } from 'react';
import { useMutation } from '@apollo/client/react';
import {
  UpdateProjectNewApartmentDocument,
  ProjectPlanDocument,
  type UpdateProjectNewApartmentInput,
} from 'graphql/generated/graphql';
import { toGraphqlError, withRaw } from 'utils/error';
import requireValue from 'utils/requireValue';

const useUpdateProjectNewApartmentMutation = () => {
  const [updateProjectNewApartmentMutation] = useMutation(UpdateProjectNewApartmentDocument);

  const mutate = useCallback(
    async (projectId: string, formData: UpdateProjectNewApartmentInput) => {
      try {
        const res = await updateProjectNewApartmentMutation({
          variables: { projectId, formData },
          refetchQueries: [{ query: ProjectPlanDocument, variables: { projectId } }],
          awaitRefetchQueries: true,
        });
        const { updateProjectNewApartment: result } = requireValue(
          res.data,
          'updateProjectNewApartment',
        );

        return result;
      } catch (error) {
        throw withRaw(toGraphqlError(error), error || '');
      }
    },
    [updateProjectNewApartmentMutation],
  );
  return mutate;
};

export default useUpdateProjectNewApartmentMutation;
